module.exports = __webpack_public_path__ + "static/media/preplay-sponsor-star6.dffcf7f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preplay-sponsor-star6.svg
// module id = ./src/assets/images/preplay-sponsor-star6.svg
// module chunks = 6